import { render, staticRenderFns } from "./EbCheckbox.vue?vue&type=template&id=527ec899&scoped=true"
import script from "./EbCheckbox.vue?vue&type=script&lang=js"
export * from "./EbCheckbox.vue?vue&type=script&lang=js"
import style0 from "./EbCheckbox.vue?vue&type=style&index=0&id=527ec899&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527ec899",
  null
  
)

export default component.exports